(() => {
  const NAV_SELECTOR = '.amr-bottom-nav';
  const BODY_CLASS = 'has-amr-bottom-nav';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function syncCartCount() {
    const headerCount = document.querySelector('.js-cart-count');
    const navBadge = document.querySelector('[data-amr-bottom-nav-count]');
    if (!headerCount || !navBadge) return;
    const count = headerCount.textContent.trim();
    navBadge.textContent = count;
    navBadge.setAttribute('data-count', count);
  }

  function getMiniCartEl() {
    if (document.body.classList.contains('template-index')) {
      const scrollCart = document.querySelector('.site-header--scroll-logo .js-mini-cart');
      if (scrollCart) return scrollCart;
    }

    const miniCarts = document.querySelectorAll('.js-mini-cart');
    for (const miniCart of miniCarts) {
      const style = window.getComputedStyle(miniCart);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        return miniCart;
      }
    }

    return miniCarts[0] || null;
  }

  function openCartDrawer() {
    const miniCarts = document.querySelectorAll('.js-mini-cart');
    if (!miniCarts.length) return false;

    miniCarts.forEach((miniCart) => miniCart.classList.add('active'));

    if (window.jQuery) {
      window.jQuery('.js-mini-cart').addClass('active');
    }

    return true;
  }

  function bindCartToggle() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-amr-bottom-nav-cart]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      if (openCartDrawer()) return;

      const cartToggle = getMiniCartEl()?.querySelector('.js-toggle-cart')
        || document.querySelector('.js-toggle-cart');
      if (!cartToggle) return;

      if (window.jQuery) {
        window.jQuery(cartToggle).trigger('click');
      } else {
        cartToggle.click();
      }
    });
  }

  function updateBarHeight() {
    const nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return;
    const bar = nav.querySelector('.amr-bottom-nav__bar');
    if (!bar) return;
    document.documentElement.style.setProperty(
      '--amr-bottom-nav-bar-height',
      `${Math.ceil(bar.getBoundingClientRect().height)}px`
    );
  }

  function boot() {
    const nav = document.querySelector(NAV_SELECTOR);
    if (!nav) return;

    document.body.classList.add(BODY_CLASS);
    bindCartToggle();
    syncCartCount();
    updateBarHeight();

    const observer = new MutationObserver(syncCartCount);
    const headerCount = document.querySelector('.js-cart-count');
    if (headerCount) {
      observer.observe(headerCount, { childList: true, characterData: true, subtree: true });
    }

    function syncBodyClass() {
      if (isMobile()) {
        document.body.classList.add(BODY_CLASS);
        updateBarHeight();
      } else {
        document.body.classList.remove(BODY_CLASS);
      }
    }

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncBodyClass, 120);
    });

    syncBodyClass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
